import * as React from 'react';
import { Grid, Typography } from '@upperhand/playmaker';

const SessionTimeAndResource = ({ session, resources }) => (
  <Grid item container justify="flex-end" alignItems="center">
    <Grid item>
      <Typography variant="h3" align="right">
        {session.startsAt.format('LT[M]')} &ndash;{' '}
        {session.endsAt.format('LT[M]')}
      </Typography>
      {resources.map(resource => (
        <Typography key={resource.id} variant="body1" align="right">
          {resource.name}
        </Typography>
      ))}
    </Grid>
  </Grid>
);

export default SessionTimeAndResource;
